import { useQueryGrid } from '@gogame/query';

import { loadSmartRulesGrid } from 'scenes/SmartRules/sources/smartRules';

import { grid } from './queryKeyFactory';

export const useSmartRulesGrid = params => {
  return useQueryGrid(grid(params), () => loadSmartRulesGrid(params));
};
